
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/british-columbia",
      function () {
        return require("private-next-pages/british-columbia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/british-columbia"])
      });
    }
  